import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from './services/chat.service';
import { takeUntil } from 'rxjs/operators';
import { Logger } from '@app/core/logging';
import { Persist } from '@app/analytics/actions/data-layer';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { AUTHENTICATED_FAILURE, LOGOUT_SUCCESS } from '@app/core/user/store/actions';
import { Actions, ofType } from '@ngrx/effects';
import { UserAccessesComponent } from '@app/core/header/components/user-accesses/user-accesses.component';

@Component({
  selector: 'vc-chat-page',
  templateUrl: './chat-page.component.html',
  styleUrls: ['./chat-page.component.scss']
})
export class ChatPageComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedChannelId: string;
  private ngUnsubscribe = new Subject<void>();
  displayListMobile = false;
  isMobile = false;
  openChatFromLike: boolean;
  @ViewChild(UserAccessesComponent, { static: false })
  userAccesses: UserAccessesComponent;

  constructor(
    private route: ActivatedRoute,
    private chatService: ChatService,
    private logger: Logger,
    private store: Store<IAppState>,
    private platformService: PlatformService,
    private action: Actions,
    private router: Router
  ) {
    // Redirect to homepage on logout
    this.action
      .pipe(takeUntil(this.ngUnsubscribe), ofType(AUTHENTICATED_FAILURE, LOGOUT_SUCCESS))
      .subscribe({ next: _ => this.router.navigateByUrl('/') });

    if (this.platformService.isBrowser) {
      this.store
        .select('device')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({ next: res => (this.isMobile = !res.isMdUp) });
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: ({ id, community }) => {
        this.selectedChannelId = id;
        // On mobile slide the container to the list of discussions if there is no channel Id to avoid blank page
        this.displayListMobile = this.isMobile && !this.selectedChannelId;
        this.openChatFromLike = community;
      }
    });
  }

  closePreviewBox() {
    if (this.userAccesses) {
      this.userAccesses.togglePreviewBox('isNotifPreviewOpened', false, 'notif', true);
    }
  }

  ngAfterViewInit() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      if (data.pageAnalytics) {
        this.store.dispatch(new Persist(data.pageAnalytics));
      }
    }, this.logger.error);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.complete();
    this.chatService.logout();
  }
}
